<div class="topbar-select">
  <mat-form-field
    fxLayout="row"
    fxFlex
    fxLayoutAlign="end"
    (click)="checkNewErfassungswellen()"
    appearance="fill"
  >
    <mat-label>Erfassungswelle</mat-label>
    <mat-select
      [formControl]="bankCtrl"
      #singleSelect
      fxFlex
      (selectionChange)="selectionChanged()"
      [panelClass]="'topbar-select-panel'"
      [panelWidth]="'400px'"
    >
      <!-- arama satırı seçilemesin -->
      <mat-option disabled>
        <ngx-mat-select-search
          [formControl]="bankFilterCtrl"
        ></ngx-mat-select-search>
      </mat-option>

      @for (bank of filteredBanks | async; track bank) {
        <mat-option [value]="bank">
          {{ bank.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
